(function() {
  'use strict';
  
  // Liquidから来る(税込)を強制削除
  function removeLiquidTaxInfo() {
    document.querySelectorAll('sale-price font').forEach(function(fontEl) {
      if (fontEl.textContent.includes('税込')) {
        fontEl.remove();
      }
    });
  }
  
  function addPriceInfo() {
    // 商品ページ以外は何もしない
    if (!document.querySelector('.product-info')) return;
    
    // まずLiquidの(税込)を削除
    removeLiquidTaxInfo();
    
    // 商品タイトルを取得
    const titleEl = document.querySelector('.product-info__title, .product-title, h1');
    const productTitle = titleEl ? titleEl.textContent : '';
    
    // すべてのsale-price要素を処理
    document.querySelectorAll('sale-price').forEach(function(priceEl) {
      // 既に処理済みならスキップ
      if (priceEl.querySelector('.price-custom-info')) return;
      
      // 価格を太字にする
      priceEl.style.fontWeight = 'bold';
      
      // 税込・送料無料を追加
      const infoSpan = document.createElement('span');
      infoSpan.className = 'price-custom-info';
      infoSpan.style.fontWeight = 'normal';
      infoSpan.style.fontSize = '0.7em';
      
      let infoText = ' (税込)';
      if (!productTitle.includes('(配送1)') && !productTitle.includes('（配送1）')) {
        infoText += ' 送料無料';
      }
      
      infoSpan.textContent = infoText;
      priceEl.appendChild(infoSpan);
    });
  }
  
  // 複数のタイミングで実行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addPriceInfo);
  } else {
    addPriceInfo();
  }
  
  // 0.5秒後、1秒後、2秒後にも実行(アプリの読み込みを待つ)
  setTimeout(addPriceInfo, 500);
  setTimeout(addPriceInfo, 1000);
  setTimeout(addPriceInfo, 2000);
  
  // 定期的にチェック(Liquidの(税込)が後から追加される場合に備えて)
  setInterval(removeLiquidTaxInfo, 200);
  
  // 価格が変更されたら再実行
  const observer = new MutationObserver(addPriceInfo);
  setTimeout(function() {
    const target = document.querySelector('.product-info');
    if (target) {
      observer.observe(target, { childList: true, subtree: true });
    }
  }, 100);
})();
